
import { Vue, Component, } from 'vue-property-decorator'
import OverlayBackground from "@/components/OverlayBackground/Index.vue"

@Component({
  components: {OverlayBackground},
  computed: {},
})
export default class StepTwo extends Vue {
  private loading = false;
  private requestReview () {
    this.loading = true
    this.$mixpanel.track('Nueva solicitud de revision', {'Actividad': this.$store.state.ActivitiesModule.ActivitiesState.SelectedActivity.name,})
    this.$store.dispatch('SteppersModule/requestReview', this.$route.params.task_id).then(() => {
      this.loading = false
      this.$emit('refresh')
    })
  }
}
